<template>
  <div class="referrals-layout">
    <div class="layout-head tab-menu-list">
      <div
        v-for="(item, index) in menuList"
        class="tab-menu-item"
        :key="index"
        :class="item.name === activeMenuName && 'is-active'"
        @click="handleMenuItemClick(item)"
      >
        <div class="tab-menu-name">{{ $t(item.meta.menuI18nKey) }}</div>
        <div class="active-line-wrapper">
          <div class="active-line"></div>
        </div>
      </div>
    </div>
    <div class="layout-content">
      <div v-if="showHeadBtn" class="content-head">
        <div
          v-for="(item, index) in headBtnList"
          class="head-btn"
          :key="index"
          :class="item.isActive && 'is-active'"
          @click="item.onclick($event, item)"
        >
          {{ $t(item.labelI18nKey) }}
        </div>
      </div>
      <router-view class="content-body" :personalInfo="personalInfo" @setHeadBtn="setHeadBtn"/>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import * as referralsRoute from '../../referralsRoute'

export default {
  props: {
    personalInfo: {
      required: true
    }
  },
  data () {
    return {
      activeMenuName: null,
      menuActiveLineStyle: {},
      headBtnList: []
    }
  },
  computed: {
    menuList () {
      const routes = [
        referralsRoute.leadsRoute,
        referralsRoute.dashboardRoute
      ]
      if (this.personalInfo?.employee?.company?.root_company?.id !== 12600) {
        routes.push(referralsRoute.rewardsRoute)
      }
      if (this.personalInfo?.employee) {
        routes.push(referralsRoute.leaderBoardRoute)
      }
      return routes
    },
    showHeadBtn () {
      return this.headBtnList.length > 0
    }
  },
  created () {
    this.refreshActiveMenuName(null)
  },
  methods: {
    refreshActiveMenuName (currentRoute) {
      currentRoute = currentRoute || this.$route
      let foundName = null
      const routeName = currentRoute.name
      let needRefreshHeadBtnList = true
      _.forEach(this.menuList, (menuItem) => {
        const menuItemName = menuItem.name
        if (menuItemName === routeName) {
          foundName = menuItemName
        } else if (menuItem.children) {
          const childMenu = _.find(menuItem.children, { name: routeName })
          if (childMenu) {
            foundName = menuItem.name
            needRefreshHeadBtnList = false
          }
        }
        return !foundName
      })
      if (needRefreshHeadBtnList) {
        this.headBtnList = []
      }
      if (foundName) {
        this.activeMenuName = foundName
      } else {
        const parentRoute = currentRoute.meta?._parent
        if (parentRoute) {
          this.refreshActiveMenuName(parentRoute)
        }
      }
    },
    handleMenuItemClick (menuItem) {
      this.$router.push({ path: menuItem.path, query: this.$route.query })
    },
    setHeadBtn (headBtns) {
      this.headBtnList = headBtns
    }
  },
  watch: {
    $route () {
      this.refreshActiveMenuName()
    }
  }
}
</script>

<style lang="scss" scoped>
.referrals-layout {
  overflow: hidden;

  .layout-head {

    &.tab-menu-list {
      display: flex;
      overflow: hidden;
      justify-content: space-between;
      margin-bottom: -1px;

      .tab-menu-item {
        flex: 1;
        margin: 0 10px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        background: #dddddd;
        box-shadow: 9px 20px 0 0 #dddddd, -9px 20px 0 0 #dddddd;
        font-size: 16px;
        cursor: pointer;
        position: relative;

        &:first-child {
          margin-left: 0px;
        }

        &:last-child {
          margin-right: 0px;
        }

        &:hover, &.is-active {
          background: #fff;
          box-shadow: 9px 20px 0 0 #fff, -9px 20px 0 0 #fff;

          .tab-menu-name {
            background: #fff;
          }

          .active-line-wrapper {
            .active-line {
              background: #0096cc;
            }
          }

          &:first-child {
            .active-line-wrapper {
              border-left: 1px solid #dddddd;
            }
          }

          &:last-child {
            .active-line-wrapper {
              border-right: 1px solid #dddddd;
            }
          }
        }

        &::before, &::after {
          content: '';
          width: 10px;
          height: 50%;
          border-bottom: 1px solid #dddddd;
          background: #fff;
          position: absolute;
          bottom: 0;
        }

        &::before {
          border-right: 1px solid #dddddd;
          left: -10px;
          border-bottom-right-radius: 5px;
        }

        &::after {
          border-left: 1px solid #dddddd;
          right: -10px;
          border-bottom-left-radius: 5px;
        }

        .tab-menu-name {
          padding: 5px;
          border: 1px solid #dddddd;
          border-bottom: 0;
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          background: #dddddd;
          overflow: hidden;
          white-space: nowrap;
          word-break: keep-all;
          text-overflow: ellipsis;
          text-align: center;
        }

        .active-line-wrapper {
          padding-top: 2px;

          .active-line {
            height: 2px;
            width: 40px;
            margin: 0 auto;
            border-radius: 5px;
            background: #dddddd;
            transition-duration: .3s;
          }
        }
      }
    }
  }

  .layout-content {
    border: 1px solid #dddddd;

    .content-head {
      display: flex;
      padding: 20px;
      border-bottom: 1px solid #dddddd;

      .head-btn {
        margin-right: 20px;
        padding: 5px 15px;
        border: 1px solid #dddddd;
        text-align: center;
        cursor: pointer;

        &:hover, &.is-active {
          background: #aaaaaa;
          color: #ffffff;
          transition-duration: .3s;
        }
      }
    }

    .content-body {
      padding: 15px;
    }
  }
}
</style>
